import {defineMessages} from 'react-intl';

export default defineMessages({
    description: {
        id: 'app.cookieBanner.description',
        defaultMessage: 'We use cookies to improve the experience.'
    },
    readMore: {
        id: 'app.cookieBanner.readMore',
        defaultMessage: 'Read more'
    },
    accept: {
        id: 'app.cookieBanner.accept',
        defaultMessage: 'OK'
    }
});
